// functions.js
// eslint-disable-next-line
import {config, types} from ".";
import proj4 from "proj4";
import { candidates } from "./party";
import parties from "../services/parties.json";
import axiosInstance from "./axiosInstance";
import React, { useState } from "react";
import ReactDOM from "react-dom";


// Define projections
const wgs84 = "EPSG:4326";
const webMercator = "EPSG:3857";

// type PartyVotes = Record<string, number>;
// type CandidateNames = Record<string, string>;
//
// interface CandidateResult {
//   partyvotes: PartyVotes;
//   kandidatenames: CandidateNames;
//   totalVotes: number;
//   totalValidVotes: number;
//   totalRejectedVotes: number;
// }
// // Define party colors
export const partyColors = {
  NPP: "#020297", // Blue
  NDC: "#4CAF50", // Green
  GUM: "#644436FF", // Red
  CPP: "#CB0F01FF", // Yellow
  PNC: "#F49005FF", // Yellow
  PPP: "#F6827AFF", // Yellow
  TIE:"#A020F0"
};

const createPartyCandidateMapping = (candidates:any, parties:any) => {
  const partyMap = {};
  candidates.forEach((candidate:any) => {
    const candidateParty = parties.find((party:any) => party.id === candidate.party_id)
    const partyKey = candidateParty.party_name?.toLowerCase();     // @ts-ignore
    if (!partyMap[partyKey]) {
      // @ts-ignore
      partyMap[partyKey] = candidate.candidate_name;
    }
  });
  return partyMap;
};



const PartyResult = ({ name = "", votes = 0, totalVotes = 0, color = "" , party = "" }) => (
  <div className="party-result" style={{fontSize: "0.8em"}} >
    <span className="party-name" style={{ color, fontWeight: "bold" }}>
      {formatName(name)} ({party.toUpperCase()}) : 
    </span>
    <span>
      {formatNumber(votes)} votes ({calculatePercentage(votes, totalVotes)})
    </span>
  </div>
);


// Utility function to render a circular avatar
const CircularAvatar = ({ imageUrl, borderColor }: { imageUrl: string; borderColor: string }) => (
  <div
    style={{
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#eee",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      margin: "0 auto 0.5em auto",
      border: `3px solid ${borderColor}`,
      backgroundImage: `url('${imageUrl || ""}')`,
    }}
  ></div>
);

// React Component for Party Results
const PartyResults = ({
  topResults,
  otherResults,
  totalVotes,
  candidateNames,
  partyColors,
}: {
  topResults: [string, number][];
  otherResults: [string, number][];
  totalVotes: number;
  candidateNames: Record<string, string>;
  partyColors: Record<string, string>;
}) => {
  const [showAll, setShowAll] = useState(false);

  const renderPartyResult = ([party, votes]: [string, number]) => {
    const partyKey = party.toUpperCase();
    const partyColor = partyColors[partyKey] || "#252525";
    const candidateName = candidateNames?.[party] || "Unknown Candidate";
    return (
      <PartyResult
        key={party}
        name={candidateName}
        votes={votes}
        totalVotes={totalVotes}
        color={partyColor}
        party={party}
      />
    );
  };

  return (
    <div>
      {topResults.map(renderPartyResult)}
      {showAll && otherResults.map(renderPartyResult)}
      {!showAll && otherResults.length > 0 && (
        <button
          style={{
            marginTop: "1em",
            padding: "5px 10px",
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowAll(true);
          }}
        >
          Show More
        </button>
      )}
    </div>
  );
};

// React Component for Winner Section
const WinnerSection = ({
  winnerCandidate,
  winnerParty,
  winnerVotes,
  totalVotes,
  winnerColor,
  partyLogo,
}: {
  winnerCandidate: string | undefined;
  winnerParty: string | undefined;
  winnerVotes: number | undefined;
  totalVotes: number;
  winnerColor: string;
  partyLogo: string;
}) => (
  <div className="winner-section" style={{ marginTop: "1em", textAlign: "center" }}>
    <CircularAvatar imageUrl={partyLogo} borderColor={winnerColor} />
    <h4 style={{ color: winnerColor, margin: 0 }}>
      {winnerCandidate || "N/A"}
      <span style={{ marginLeft: 5, fontSize: "0.9em" }}>({winnerParty || "N/A"})</span>
    </h4>
    <p style={{ margin: "0.5em 0", fontWeight: "bold" }}>
      {calculatePercentage(winnerVotes || 0, totalVotes)} ({formatNumber(winnerVotes || 0)} votes)
    </p>
  </div>
);

// Generic Popup Renderer
const renderPopup = (
  layer: any,
  PopupContent: React.FC,
  className: string
) => {
  const popupContainer = document.createElement("div");
  ReactDOM.render(<PopupContent />, popupContainer);
  layer
    .bindPopup(popupContainer, { className, maxWidth: 400 })
    .openPopup();
};

// Constituency Popup Function
export function showConstituencyPopup(layer: any, props: any) {
  console.log(props)
  const totalVotes = Number(props.totalvotes || 0);
  const winnerParty = props["winner.party"];
  const winnerVotes = props["winner.votes"];
  const winnerCandidate = props["winner.candidate"];
    const winnerData =
        candidates[winnerParty?.toUpperCase() as keyof typeof candidates] || {};
    const winnerColor =
        partyColors[winnerParty?.toUpperCase() as keyof typeof partyColors] ||
      "#ccc";
  
  let constituencyName =
    props?.const_name || props?.constituency_name;
     if (!constituencyName) {
              constituencyName = "";
              console.log(
                "constituencyName  is missing in the GeoJSON properties."
              );
              return;
            }


  const sortedResults = Object.entries(props.partyvotes || {})
  .map(([party, votes]) => [party, Number(votes||0)] as [string, number]) // Ensure votes are numbers
  .sort(([, votesA], [, votesB]) => votesB - votesA);


  const topResults = sortedResults.slice(0, 3);
  const otherResults = sortedResults.slice(3);

  const PopupContent = () => (
    <div className="constituency-popup">
      <h3><strong>Region: </strong> {props.region?.toUpperCase() || "N/A"}</h3>
      <div><strong>Constituency: </strong> {constituencyName?.toUpperCase() || "N/A"}</div>
      <div><strong>Total Votes: </strong> {formatNumber(totalVotes)}</div>
      <WinnerSection
        winnerCandidate={winnerCandidate}
        winnerParty={winnerParty}
        winnerVotes={winnerVotes}
        totalVotes={totalVotes}
        winnerColor={winnerColor}
        partyLogo={winnerData.partyLogo || ""}
      />
      <div className="party-results" style={{ marginTop: "1em" }}>
        <PartyResults
          topResults={topResults}
          otherResults={otherResults}
          totalVotes={totalVotes}
          candidateNames={props.candidatenames || {}}
          partyColors={partyColors}
        />
      </div>
      <p className="popup-hint" style={{ marginTop: "1em" }}>Double-click to view constituencies</p>
    </div>
  );

  renderPopup(layer, PopupContent, "constituency-popup");
}
// Constituency Popup Function
export function showRegionalPopup(layer: any, props: any) {
  const totalVotes = Number(props.totalvotes || 0);
  const winnerParty = props["winner.party"];
  const winnerVotes = props["winner.votes"];
  const winnerCandidate = props["winner.candidate"];

    const winnerData =
        candidates[winnerParty?.toUpperCase() as keyof typeof candidates] || {};
    const winnerColor =
        partyColors[winnerParty?.toUpperCase() as keyof typeof partyColors] ||
      "#ccc";

  const sortedResults = Object.entries(props.partyvotes || {})
  .map(([party, votes]) => [party, Number(votes||0)] as [string, number]) // Ensure votes are numbers
  .sort(([, votesA], [, votesB]) => votesB - votesA);


  const topResults = sortedResults.slice(0, 3);
  const otherResults = sortedResults.slice(3);

  const PopupContent = () => (
    <div className="regional-popup">
      <h3><strong>Region: </strong> {props.region?.toUpperCase() || "N/A"}</h3>
      <div><strong>Total Constituencies: </strong> {props.totalconstituencies || "N/A"}</div>
      <div><strong>Total Votes: </strong> {formatNumber(totalVotes)}</div>
      <WinnerSection
        winnerCandidate={winnerCandidate}
        winnerParty={winnerParty}
        winnerVotes={winnerVotes}
        totalVotes={totalVotes}
        winnerColor={winnerColor}
        partyLogo={winnerData.partyLogo || ""}
      />
      <div className="party-results" style={{ marginTop: "1em" }}>
        <PartyResults
          topResults={topResults}
          otherResults={otherResults}
          totalVotes={totalVotes}
          candidateNames={props.candidatenames || {}}
          partyColors={partyColors}
        />
      </div>
      <p className="popup-hint" style={{ marginTop: "1em" }}>Double-click to view constituencies</p>
    </div>
  );

  renderPopup(layer, PopupContent, "regional-popup");
}



// Function to format numbers with commas
export function formatNumber(num: number) {
  return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "N/A";
}
// Function to calculate percentage
export function calculatePercentage(part: number, whole: number) {
  if (!part || !whole) return "N/A";
  return ((part / whole) * 100).toFixed(1) + "%";
}
// Function to calculate percentage
export function formatName(name: string) {
  name = name.replaceAll("_", " ").toWellFormed();
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const transformGeoData = (data: any) => {
  return (data.features = data.features.map((feature: any) => {
    return {
      ...feature,
      geometry: {
        ...feature.geometry,
        coordinates: feature.geometry.coordinates.map((polygon: any) =>
          polygon.map((ring: any) =>
            ring.map((coord: any) => proj4(webMercator, wgs84, coord))
          )
        ),
      },
    };
  }));
};

export const formatLiveFeatureData = (feature: any,electionResults:any,candidates:any) => {
  const initialPartyVotes = {}
  parties.forEach((party:any) => {
    const partyKey = party.party_name.toLowerCase().replace(/\s+/g, '_');
    // @ts-ignore
    if(!initialPartyVotes[partyKey]){  // @ts-ignore
      initialPartyVotes[partyKey] = 0
    }
  });
  const aggregated = (electionResults || []).reduce((acc:any, result:any) => {
    acc.totalValidVotes += result.total_valid_votes || 0;
    acc.totalRejectedVotes += result.total_rejected_ballots || 0;
    acc.totalVotesCast += result.total_vote_cast || 0;
    // @ts-ignore
    result.party_votes.forEach(({ party_id, votes }) => {
      const party = parties.find(p => p.id === party_id);
      if (party) {
        const partyKey = party.party_name.toLowerCase().replace(/\s+/g, '_');
        // @ts-ignore
        acc.partyVotes[partyKey] = (acc.partyVotes[partyKey] || 0) + votes;
        if(party.party_name ==="ndc"){
          acc.partyVotes[partyKey] = (acc.partyVotes[partyKey] || 0) + 1000;
        }
      }
    });

    return acc;
  }, {
    totalValidVotes: 0,
    totalRejectedVotes: 0,
    totalVotesCast: 0,
    partyVotes: {
      ...initialPartyVotes
    },
  });
  let winner = getWinner(aggregated)
  return {
    ...feature.properties,
    year: 2024,
    totalconstituencies: electionResults.length,
    totalvotes: aggregated.totalVotesCast,
    rejectedvotes: aggregated.totalRejectedVotes,
    totalvalidvotes: aggregated.totalValidVotes,
    "winner.party": winner?.party?.toUpperCase(),
    "winner.candidate": "Bawu", // Placeholder for candidate name
    "winner.votes": winner?.votes,
    "winner.percentage": winner?.percentage,
    "demographics.population": null, // Placeholder for population data
    "demographics.eligiblevoters": null, // Placeholder for eligible voters
    "demographics.turnoutpercentage": ((aggregated.totalVotesCast / (aggregated.totalValidVotes + aggregated.totalRejectedVotes)) * 100).toFixed(2),
    "coordinates of region": null, // Placeholder for region coordinates
    partyvotes: aggregated.partyVotes,
    candidatenames:createPartyCandidateMapping(candidates,parties),
  };
};

function getWinner (aggregated: any)  {
  let winner = null;
  let highestVotes = 0;
  let tie = false;

  for (const [party, votes] of Object.entries(aggregated.partyVotes)) {
    if (votes as number > highestVotes) {
      highestVotes = votes as number ;
      winner = {
        party,
        votes,
        percentage: ((votes as number / aggregated.totalVotesCast) * 100).toFixed(2),
      };
      tie = false; // Reset tie flag
    } else if (votes === highestVotes) {
      tie = true; // A tie is detected
    }
  }

  // Return null if there is a tie or no votes
  return tie && highestVotes> 0 ? {
    votes: highestVotes,
    party: "tie",
  } : winner;
};

export const calculateTotalVotesByParty = (parties:any, electionData:any) => {
  const votesByParty = {};
  // Loop through each election record
  electionData.forEach((record:any) => {
    record.party_votes.forEach((vote:any) => {
      const party = parties.find((p:any) => p.id === vote.party_id);

      if (party) {
        // Add votes to the corresponding party name
        // @ts-ignore
        votesByParty[party.party_name] = (votesByParty[party.party_name] || 0) + vote.votes;
      }
    });
  });

  return votesByParty;
}

export const calculateTotalVotesByCandidate = (
    candidates: any[],
    electionData: any[],
    parties: any[]
) => {
  const votesByCandidate: { [key: string]: { votes: number; color: string; img: string,party_name: string } } = {};

  // Initialize votesByCandidate with all candidates defaulting to 0 votes
  candidates.forEach((candidate: any) => {
    const candidateKey = candidate.candidate_name.toLowerCase().replace(/\s+/g, '_');
    const party = parties.find((p: any) => p.id === candidate.party_id);

    votesByCandidate[candidateKey] = {
      votes: 0, // Default to 0 votes
      color: party?.party_color || '#000000', // Default to black if no party color
      img: candidate?.img || '',
      party_name : party.party_name// Default to an empty string for image
    };
  });

  // Update votes based on election data
  electionData.forEach((record: any) => {
    record.party_votes.forEach((vote: any) => {
      const candidate = candidates.find((c: any) => c.party_id === vote.party_id);
      const candidateKey = candidate?.candidate_name.toLowerCase().replace(/\s+/g, '_');

      if (candidateKey && votesByCandidate[candidateKey]) {
        votesByCandidate[candidateKey].votes += vote.votes;
      }
    });
  });

  // Convert the object to an array, sort by votes, and convert back to object if needed
  const sortedVotesArray = Object.entries(votesByCandidate)
      .sort(([, a], [, b]) => b.votes - a.votes) // Sort descending by votes
      .map(([key, value]) => ({ candidate: key, ...value })); // Add the candidate key in the output
  return sortedVotesArray;
};


export const processElectionParliamentaryResults = (
    geoJson: any,
    results: any,
    parties: any
) => {
  const winners = geoJson.map((feature: any) => {
    const constituencyName = feature.properties.const_name;

    // Filter results for this constituency
    const constituencyResults = results.filter(
        (result: any) => result.constituency_name === constituencyName
    );
    if (constituencyResults.length === 0) {
      return null; // No results available
    }

    // Aggregate votes for each party
    const aggregatedVotes: { [partyId: number]: number } = {};
    constituencyResults.forEach((result: any) => {
      result.party_votes.forEach((vote: any) => {
        aggregatedVotes[vote.party_id] =
            (aggregatedVotes[vote.party_id] || 0) + vote.votes;
      });
    });

    // Find the maximum votes
    const maxVotes = Math.max(...Object.values(aggregatedVotes));

    // Identify parties with the maximum votes
    const topParties = Object.entries(aggregatedVotes).filter(
        ([, votes]) => votes === maxVotes
    );

    if (topParties.length > 1) {
      // If there's a tie, return a "Tie" object
      return {
        party_name: "Tie",
        party_color: "#8A2BE2", // Violet color for ties
        votes: maxVotes, // Include the tied votes count
      };
    }

    const winningPartyId = parseInt(topParties[0][0], 10);
    const winningParty = parties.find(
        (party: any) => party.id === winningPartyId
    );

    if (winningParty) {
      return {
        ...winningParty,
        votes: maxVotes, // Include the winning party's vote count
      };
    }

    return null; // Return null if the winning party is not found
  });

  return winners;
};


export const createSeatsVisualization = (winners:any) => {
  const container = document.getElementById("seats-container");
  if (!container) {
    console.error("Seats container not found!");
    return;
  }
  container.innerHTML = "";
  const partySeatCounts = winners.reduce((counts:number, winner:any) => {
    if (winner && winner.party_name) {   // @ts-ignore
      counts[winner.party_name] = (counts[winner.party_name] || 0) + 1;
    }
    return counts;
  }, {});

  const sortedParties = Object.entries(partySeatCounts)   // @ts-ignore
      .sort(([, countA], [, countB]) => countB - countA)
      .slice(0, 2); // Get the top 2 parties
  const header = document.createElement("div");
  header.className = "flex justify-between mb-4";
  sortedParties.forEach(([partyName, seatCount], index) => {
    const partyInfo = document.createElement("div");
    partyInfo.innerHTML = `<div class="font-bold text-lg" >${index + 1}. ${partyName}</div>
                           <div class="text-sm">Seats: ${seatCount}</div>`;
    header.appendChild(partyInfo);
  });

  container.appendChild(header);

  const seatsContainer = document.createElement("div");
  seatsContainer.className = "flex flex-wrap";
  winners.forEach((winner: any) => {
    const dot = document.createElement("div");
    dot.className = "h-8 w-8 rounded-full inline-block m-1 relative cursor-pointer";
    dot.style.backgroundColor = winner?.party_color || "#CCCCCC";

    // Create popover
    const popover = document.createElement("div");
    popover.className = "absolute bg-white text-black p-2 w-[100px] rounded shadow hidden z-10";
    popover.style.top = "1.5rem"; // Position the popover
    popover.style.left = "-0.5rem";
    popover.innerHTML = `
      <div class="font-bold">${winner?.party_name || "No Winner"}</div>
      <div class="text-sm">Votes: ${winner?.votes || "N/A"}</div>
    `;
    dot.appendChild(popover);

    // Show/hide popover on click
    dot.addEventListener("click", () => {
      // Hide all other popovers
      const allPopovers = document.querySelectorAll(".absolute");
      allPopovers.forEach((popoverElement: any) => {
        popoverElement.style.display = "none";
      });

      // Toggle the clicked popover
      const isVisible = popover.style.display === "block";
      popover.style.display = isVisible ? "none" : "block";
    });

    seatsContainer.appendChild(dot);
  });

  container.appendChild(seatsContainer);
};


export const fetchElectionResults = async (view?:string) => {
  try{
    const response  = await axiosInstance.get(`${config.api.endpoints.results_by_election_type}/?election_type=${view?.toLowerCase()}`);
    return response.data  || []
  }catch (e) {
    return []
  }
};

export const fetchElectionResultsByConst = async (constCode?:string) => {
  try{
    const response  = await axiosInstance.get(`${config.api.endpoints.results_by_const_code}/K0401`);
    return response.data
    // return electionResults
  }catch (e) {
    return []
  }
};


